import { ScaleElement } from '@scale/base-element';

class ScaleAnnouncementBar extends ScaleElement {
  #currentSlide = 0;
  #autoplayInterval;
  #slideItems = [];
  #isPaused = false;

  setup() {
    if (this.hasAttribute('data-dismissible')) {
      this.#checkDismissed();
    }

    const slides = this.ref('slides');
    if (slides) {
      this.#slideItems = [...slides.children];
      if (this.#slideItems.length > 0) {
        this.#slideItems[0].classList.add('is-active');
      }
      if (this.#slideItems.length > 1) {
        this.#startAutoplay();

        if (this.hasAttribute('data-pause-on-hover')) {
          this.on('mouseenter', () => {
            this.#isPaused = true;
            this.#stopAutoplay();
          });
          this.on('mouseleave', () => {
            this.#isPaused = false;
            this.#startAutoplay();
          });
        }
      }
    }

    if (this.hasAttribute('data-marquee')) {
      this.#setupMarquee();
    }
  }

  teardown() {
    this.#stopAutoplay();
  }

  // --- Slider ---

  next() {
    this.#goTo((this.#currentSlide + 1) % this.#slideItems.length);
    this.#restartAutoplay();
  }

  prev() {
    this.#goTo((this.#currentSlide - 1 + this.#slideItems.length) % this.#slideItems.length);
    this.#restartAutoplay();
  }

  #goTo(index) {
    this.#slideItems[this.#currentSlide]?.classList.remove('is-active');
    this.#slideItems[index]?.classList.add('is-active');
    this.#currentSlide = index;
  }

  #startAutoplay() {
    if (this.#autoplayInterval || this.#isPaused) return;
    const speed = this.getNumber('autoplay', 5) * 1000;
    this.#autoplayInterval = setInterval(() => this.next(), speed);
  }

  #stopAutoplay() {
    clearInterval(this.#autoplayInterval);
    this.#autoplayInterval = null;
  }

  #restartAutoplay() {
    this.#stopAutoplay();
    const wasPaused = this.#isPaused;
    this.#isPaused = false;
    this.#startAutoplay();
    this.#isPaused = wasPaused;
  }

  // --- Marquee ---

  #setupMarquee() {
    const speed = this.getNumber('marquee-speed', 30);
    const track = this.ref('track');
    if (track) {
      track.style.setProperty('--marquee-duration', `${speed}s`);
    }
  }

  // --- Dismissible ---

  dismiss() {
    const sectionId = this.dataset.sectionId;
    try {
      sessionStorage.setItem(`scale:announcement-dismissed:${sectionId}`, 'true');
    } catch { /* quota */ }
    this.classList.add('announcement-bar--dismissed');
  }

  #checkDismissed() {
    const sectionId = this.dataset.sectionId;
    try {
      if (sessionStorage.getItem(`scale:announcement-dismissed:${sectionId}`) === 'true') {
        this.classList.add('announcement-bar--dismissed');
      }
    } catch { /* private browsing */ }
  }
}

if (!customElements.get('scale-announcement-bar')) {
  customElements.define('scale-announcement-bar', ScaleAnnouncementBar);
}
